module.exports = __webpack_public_path__ + "static/media/img-article-destress.f71a153f.png";